var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-tree-select',{attrs:{"value":_vm.defaultValue,"dropdown-style":{ maxHeight: '300px', overflow: 'auto' },"label-in-value":false,"tree-data":_vm.treeData,"multiple":false,"replace-fields":_vm.replaceFields,"disabled":_vm.disabled},on:{"change":_vm.change}})
}
var staticRenderFns = []

export { render, staticRenderFns }